module.exports = __webpack_public_path__ + "img/fondy_logo.fcc707b7.png";